import React, { useMemo, useState } from 'react';
import { buildVbcompilerPayload, validatePayload } from '../utils/normalizer';

interface NormalizeModalProps {
  onClose: () => void;
  onInsert: (payloadJson: string) => void; // devolve JSON pronto para colar no editor
}

export function NormalizeModal({ onClose, onInsert }: NormalizeModalProps) {
  const [raw, setRaw] = useState('');
  const [vbid, setVbid] = useState('convert_object');
  const [progress, setProgress] = useState(false);
  const [progressEvery, setProgressEvery] = useState(3);
  const [progressIntervalMs, setProgressIntervalMs] = useState(150);
  const [progressLabel, setProgressLabel] = useState('Conversão/Bitmap');
  const [uiModal, setUiModal] = useState(false);
  const [uiCancelable, setUiCancelable] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [copied, setCopied] = useState(false);

  const preview = useMemo(() => {
    const payload = buildVbcompilerPayload({
      vbid,
      code: raw,
      progress,
      progressEvery,
      progressIntervalMs,
      progressLabel,
      uiModal,
      uiCancelable,
    });
    return JSON.stringify(payload, null, 2);
  }, [raw, vbid, progress, progressEvery, progressIntervalMs, progressLabel, uiModal, uiCancelable]);

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-2">
      <div className="w-full max-w-3xl bg-navy-800 rounded-lg border border-navy-700 overflow-hidden">
        <div className="flex items-center justify-between p-2 border-b border-navy-700">
          <h3 className="text-xs font-semibold text-white">Normalizar VB.NET</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white text-[11px] px-2 py-1">Fechar</button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 p-2">
          <div>
            <label className="block text-[11px] text-gray-400 mb-1">Código VB.NET</label>
            <textarea
              value={raw}
              onChange={(e) => setRaw(e.target.value)}
              className="w-full h-40 p-2 bg-navy-900/50 border border-navy-700 rounded text-[11px] text-gray-200 font-mono"
              placeholder="Cole o VB.NET aqui..."
            />

            <div className="grid grid-cols-2 gap-2 mt-2 text-[11px] text-gray-300">
              <div>
                <label className="block mb-1">vbid</label>
                <input value={vbid} onChange={(e) => setVbid(e.target.value)} className="w-full px-2 py-1 bg-navy-900/50 border border-navy-700 rounded" />
              </div>
              <div className="flex items-center gap-2 mt-5">
                <label className="flex items-center gap-1"><input type="checkbox" checked={progress} onChange={(e) => setProgress(e.target.checked)} /> progress</label>
                <label className="flex items-center gap-1"><input type="checkbox" checked={uiModal} onChange={(e) => setUiModal(e.target.checked)} /> uiModal</label>
                <label className="flex items-center gap-1"><input type="checkbox" checked={uiCancelable} onChange={(e) => setUiCancelable(e.target.checked)} /> uiCancelable</label>
              </div>
              {progress && (
                <>
                  <div>
                    <label className="block mb-1">progressEvery</label>
                    <input type="number" value={progressEvery} onChange={(e) => setProgressEvery(parseInt(e.target.value || '0', 10))} className="w-full px-2 py-1 bg-navy-900/50 border border-navy-700 rounded" />
                  </div>
                  <div>
                    <label className="block mb-1">progressIntervalMs</label>
                    <input type="number" value={progressIntervalMs} onChange={(e) => setProgressIntervalMs(parseInt(e.target.value || '0', 10))} className="w-full px-2 py-1 bg-navy-900/50 border border-navy-700 rounded" />
                  </div>
                  <div className="col-span-2">
                    <label className="block mb-1">progressLabel</label>
                    <input value={progressLabel} onChange={(e) => setProgressLabel(e.target.value)} className="w-full px-2 py-1 bg-navy-900/50 border border-navy-700 rounded" />
                  </div>
                </>
              )}
            </div>

            <div className="mt-2 flex gap-2">
              <button
                onClick={() => {
                  const payload = JSON.parse(preview);
                  const errs = validatePayload(payload);
                  setErrors(errs);
                }}
                className="px-2 py-1 text-[11px] rounded bg-green-600 hover:bg-green-700 text-white"
              >
                Normalizar
              </button>
              <button
                onClick={() => {
                  const payload = JSON.parse(preview);
                  onInsert(JSON.stringify(payload, null, 2));
                  onClose();
                }}
                className="px-2 py-1 text-[11px] rounded bg-blue-600 hover:bg-blue-700 text-white"
              >
                Inserir no Editor
              </button>
            </div>

            {errors.length > 0 && (
              <div className="mt-2 text-[11px] text-red-400 space-y-1">
                {errors.map((e, i) => (<div key={i}>• {e}</div>))}
              </div>
            )}
          </div>

          <div>
            <div className="flex items-center justify-between mb-1">
              <label className="block text-[11px] text-gray-400">Preview do Payload (JSON)</label>
              <button
                onClick={async () => {
                  await navigator.clipboard.writeText(preview);
                  setCopied(true);
                  setTimeout(() => setCopied(false), 1500);
                }}
                className="px-2 py-1 text-[11px] rounded bg-gray-700 hover:bg-gray-600 text-gray-200"
              >
                {copied ? 'Copiado!' : 'Copiar'}
              </button>
            </div>
            <pre className="w-full h-56 p-2 bg-navy-900/50 border border-navy-700 rounded text-[11px] text-gray-200 font-mono overflow-auto">{preview}</pre>
          </div>
        </div>
      </div>
    </div>
  );
}


